import React from 'react'
import './loader.scss'

const Spinner = () => {
    return (
        <div className='loader_spinner'></div>
    )
}
 
export default Spinner